import { render, staticRenderFns } from "./professional_atendimentos.vue?vue&type=template&id=630daa54"
import script from "./professional_atendimentos.vue?vue&type=script&lang=js"
export * from "./professional_atendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports